/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OdChargeIdEnum } from './odChargeIdEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface MetricInfoPostSpec { 
    internal_charge_id: string;
    metric_uom: string;
    od_charge_id: OdChargeIdEnum;
    process_usage_eligible: boolean;
    metric_name: string;
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace MetricInfoPostSpec {
}


